// test580
(580 && 0);
